<template>
  <div class="hub-running-pendding">
    <img src="../../../assets/img-v2/ic_running_clock.png" class="icon" />
    <div class="right">
      <div v-html="hubStatusDesc" class="title"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    hubStatusDesc() {
      let { hubStatusDesc } = this.orderInfo || {};
      return hubStatusDesc;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.hub-running-pendding {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 6px;
  .right {
    flex: 1;
    margin-left: 4px;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    padding-top: 6px;

    ::v-deep .subtitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
    }

    ::v-deep .blue {
      font-family: DINAlternate, DINAlternate;
      font-weight: 500;
      font-size: 24px;
      color: #006efa;
      line-height: 28px;
    }
  }

  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #00000099;
    line-height: 16px;
    margin-top: 3px;
    ::v-deep .blue {
      font-weight: 500;
      color: #006efa;
    }
  }

  .icon {
    width: 54px;
    height: 54px;
  }
}
</style>
